import { useState } from 'react'

export const usePagination = (size, step) => {
  const firstPage = 0
  const lastPage = size - 1

  const [page, setPage] = useState(firstPage)

  const hasNext = () => page + step < lastPage

  const hasPrev = () => page - step >= firstPage

  const goNext = () => setPage(Math.min(page + step, lastPage))

  const goPrev = () => setPage(Math.max(page - step, firstPage))

  return {
    page,
    goNext,
    goPrev,
    hasNext,
    hasPrev,
  }
}
